
export class VibrationEvent {
    public readonly type: string = nameof(VibrationEvent);

    public readonly isVibrationEvent: true = true;
}